<template>
  <main class="page gallery-page" v-if="$store.state.photos">
    <div class="gallery-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home' }">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'gallery' }">Галерея</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ $store.state.photos.name }}</span>
        </li>
      </ul>
      <h1 class="gallery-page__title">{{ $store.state.photos.name }}</h1>
      <div class="gallery-page__items" id="lightgallery">
        <a v-for="(photo, index) in $store.state.photos.img_gallery_inner_not_paginate" :key="index" class="gallery-page__item" :href="photo | findSource2($store.state.api)" :title='$store.state.photos.name' :aria-label='$store.state.photos.name'>
          <img class="gallery__image" :src="photo | findSource2($store.state.api)" :alt='$store.state.photos.name' @error="error"/>
        </a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  async asyncData ({ store, host, route }) {
    await store.dispatch('PHOTOS_PAGE', route.params.id)
  },
  name: 'PhotosPage',
  mounted () {
    require(['lightgallery.js'], () => {
      require(['lg-thumbnail.js'], () => {
        // eslint-disable-next-line no-undef
        lightGallery(document.getElementById('lightgallery'), {
          thumbnail: true
        })
      })
    })
  },
  methods: {
    error (e) {
      if (e.target.src !== '/public/img/gallery-placeholder.svg') e.target.src = '/public/img/gallery-placeholder.svg'
    }
  },
  metaInfo () {
    return this.$store.state.photos ? this.$seo(
      'common',
      this.$store.state.photos.name,
      'управление образования, образование, администрация',
      '',
      this.$store.state.photos.name,
      this.$options.filters.findSource(this.$store.state.photos.img_gallery_inner_not_paginate, this.$store.state.api),
      ''
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
